/* Ekoh boxing listicle — countdowns, {count} token, CTA param passthrough, pixel events */
(function () {
  'use strict';
  var G = window.EkohListicle || (window.EkohListicle = {});

  /* ---------------- countdowns ---------------- */
  function pad(n) { return n < 10 ? '0' + n : '' + n; }

  function startTimer(el) {
    var raw = el.getAttribute('data-end') || '';
    if (raw === 'inherit') raw = G.endDate || '';
    var end = Date.parse(String(raw).replace(' ', 'T'));
    var out = {};
    el.querySelectorAll('[data-u]').forEach(function (n) { out[n.getAttribute('data-u')] = n; });
    if (isNaN(end)) { el.classList.add('is-over'); return; }

    /* Rolling deadline. When loopDays > 0 the deadline advances in whole cycles from the
       original date, so it is computed from the calendar and is identical for every
       visitor on every device. It is NOT a per-visitor timer: nothing is stored, and a
       reload or a new visitor lands on exactly the same moment in the same cycle. */
    var loopDays = parseInt(el.getAttribute('data-loop') || '0', 10);
    if (!loopDays && raw === (G.endDate || '')) loopDays = parseInt(G.loopDays || 0, 10);
    var period = loopDays > 0 ? loopDays * 86400000 : 0;
    function deadline() {
      if (!period) return end;
      var now = Date.now();
      if (now < end) return end;
      return end + Math.ceil((now - end) / period) * period;
    }

    var iv;
    function tick() {
      var ms = deadline() - Date.now();
      if (ms <= 0) { el.classList.add('is-over'); el.classList.remove('is-days'); if (iv) clearInterval(iv); return; }
      el.classList.remove('is-over');
      var t = Math.floor(ms / 1000), d = Math.floor(t / 86400);
      if (d > 0) { el.classList.add('is-days'); if (out.d) out.d.textContent = pad(d); }
      else { el.classList.remove('is-days'); }
      if (out.h) out.h.textContent = pad(Math.floor(t % 86400 / 3600));
      if (out.m) out.m.textContent = pad(Math.floor(t % 3600 / 60));
      if (out.s) out.s.textContent = pad(t % 60);
    }
    tick();
    iv = setInterval(tick, 1000);
  }

  function initTimers() {
    if (G.timersOff) {
      document.querySelectorAll('[data-ek-countdown], [data-ek-timer-host]').forEach(function (el) { el.style.display = 'none'; });
      return;
    }
    document.querySelectorAll('[data-ek-countdown]').forEach(startTimer);
  }

  /* ---------------- {count} token ---------------- */
  function initCount() {
    var n = document.querySelectorAll('[data-reason]').length;
    if (!n) return;
    document.querySelectorAll('[data-ek-count]').forEach(function (el) {
      el.textContent = String(n + 1);
    });
  }

  /* ---------------- CTA urls: default, passthrough, pixel ---------------- */
  var PASS_PREFIXES = ['utm_'];
  var PASS_EXACT = ['fbclid', 'gclid', 'ttclid', 'msclkid', 'ref', 'campaign_id', 'adset_id', 'ad_id'];

  function incoming() {
    var out = [];
    try {
      new URLSearchParams(window.location.search).forEach(function (v, k) {
        var keep = PASS_EXACT.indexOf(k) !== -1;
        if (!keep) { for (var i = 0; i < PASS_PREFIXES.length; i++) { if (k.indexOf(PASS_PREFIXES[i]) === 0) { keep = true; break; } } }
        if (keep) out.push([k, v]);
      });
    } catch (e) { /* no-op */ }
    return out;
  }

  function initCtas() {
    var extra = incoming();
    document.querySelectorAll('a[data-cta-id]').forEach(function (a) {
      var href = a.getAttribute('href');
      if (!href || href === '#' || href === '') { href = G.defaultCta || ''; }
      if (!href) { return; }
      var url;
      try { url = new URL(href, window.location.origin); }
      catch (e) { a.setAttribute('href', href); return; }
      extra.forEach(function (kv) { if (!url.searchParams.has(kv[0])) url.searchParams.set(kv[0], kv[1]); });
      a.setAttribute('href', url.pathname + url.search + url.hash);

      a.addEventListener('click', function () {
        var name = G.pixelEvent || 'PrelanderCTAClick';
        var id = a.getAttribute('data-cta-id') || 'unknown';
        try { if (typeof window.fbq === 'function') window.fbq('trackCustom', name, { button: id }); } catch (e) { /* no-op */ }
        try { if (typeof window.dataLayer !== 'undefined' && window.dataLayer.push) window.dataLayer.push({ event: name, button: id }); } catch (e) { /* no-op */ }
      });
    });
  }

  /* ---------------- noindex ---------------- */
  function initNoindex() {
    if (!G.noindex) return;
    if (document.querySelector('meta[name="robots"][data-ek]')) return;
    var m = document.createElement('meta');
    m.setAttribute('name', 'robots');
    m.setAttribute('content', 'noindex, nofollow');
    m.setAttribute('data-ek', '1');
    document.head.appendChild(m);
  }

  /* ---------------- sticky mobile CTA ---------------- */
  function initSticky() {
    var bar = document.querySelector('[data-ek-sticky]');
    if (!bar) return;
    var afterN = parseInt(bar.getAttribute('data-after') || '3', 10);
    var reasons = document.querySelectorAll('[data-reason]');
    var trigger = reasons[afterN - 1];
    if (!trigger) return;
    function onScroll() {
      var top = trigger.getBoundingClientRect().top;
      bar.classList.toggle('is-on', top < 0);
    }
    onScroll();
    window.addEventListener('scroll', onScroll, { passive: true });
  }

  /* ---------------- lazy videos ----------------
     Sources sit in data-src until the slot nears the viewport, so videos below the
     first screen download nothing on load. Above-the-fold slots intersect
     immediately, so they start without delay. */
  function initVideos() {
    var vids = document.querySelectorAll('video[data-ek-video]');
    if (!vids.length) return;

    function activate(v) {
      if (v.getAttribute('data-ek-loaded')) { tryPlay(v); return; }
      v.setAttribute('data-ek-loaded', '1');
      var got = false;
      v.querySelectorAll('source[data-src]').forEach(function (s) {
        s.setAttribute('src', s.getAttribute('data-src'));
        s.removeAttribute('data-src');
        got = true;
      });
      if (!got) return;
      try { v.load(); } catch (e) { /* no-op */ }
      tryPlay(v);
    }

    function tryPlay(v) {
      var p = v.play();
      if (p && typeof p.catch === 'function') { p.catch(function () { /* autoplay refused; poster stays */ }); }
    }

    if (!('IntersectionObserver' in window)) { vids.forEach(activate); return; }

    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) { activate(e.target); }
        else if (e.target.getAttribute('data-ek-loaded') && !e.target.paused) {
          try { e.target.pause(); } catch (err) { /* no-op */ }
        }
      });
    }, { rootMargin: '400px 0px' });

    vids.forEach(function (v) { io.observe(v); });
  }

  function boot() { initNoindex(); initCount(); initTimers(); initCtas(); initSticky(); initVideos(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
})();
